import { render, staticRenderFns } from "./SinglePrefixTitle.vue?vue&type=template&id=fcd330fc"
import script from "./SinglePrefixTitle.vue?vue&type=script&lang=js"
export * from "./SinglePrefixTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports